<div class="d-flex flex-column mb-4" *ngIf="loading$|async">
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div class="card card-custom">
	<div class="card-header">
		<div class="card-title">
			<span *ngIf="title">{{title}}</span>
		</div>
		<div class="card-toolbar">
			<div class="d-flex justify-content-end">
				<button mat-raised-button color="secondary" type="button" class="btn btn-secondary mr-4" (click)="addInvoice()">
					Add
				</button>
			</div>
		</div>
	</div>

	<div class="card-body">
		<div class="mat-table-wrapper">
			<mat-table [dataSource]="dataSource">
				<ng-container matColumnDef="invoice_number">
					<mat-header-cell *matHeaderCellDef>Invoice Number</mat-header-cell>
					<mat-cell *matCellDef="let item">
						{{item.invoice_number}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="amount">
					<mat-header-cell *matHeaderCellDef>
						{{currency ? 'Amount (' + currency + ')' : 'Amount'}}
					</mat-header-cell>
					<mat-cell *matCellDef="let item">
						{{item.amount | number: '1.2-2'}}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="actions">
					<mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
					<mat-cell *matCellDef="let item">
						<span [matTooltip]="item.file_path ? 'Download' : 'No file uploaded'">
							<button mat-icon-button color="primary" (click)="downloadFile(item)" type="button"
								[disabled]="!item.file_path">
								<mat-icon>get_app</mat-icon>
							</button>
						</span>
						<button mat-icon-button color="primary" matTooltip="Edit" (click)="editInvoice(item)" type="button">
							<mat-icon>create</mat-icon>
						</button>
						<button mat-icon-button color="warn" matTooltip="Delete" (click)="deleteInvoice(item)" type="button">
							<mat-icon>delete</mat-icon>
						</button>
					</mat-cell>
				</ng-container>
				<mat-header-row *matHeaderRowDef="columns" [style.backgroundColor]="'#fcdea2'"></mat-header-row>
				<mat-row *matRowDef="let row; columns: columns"></mat-row>
			</mat-table>
		</div>
	</div>
</div>
